<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="folder-wrapper">
    <div *ngIf="false">
        <div class="import-btn">
            <div>
                <button id="import-folders-button" color="primary" mat-raised-button (click)="onImportClick()" aria-label="Import folders.">
                    <span class="mdi mdi-download"></span>
                    <span class="add-button-label">{{'IMPORT' | translate}}</span>
                </button>
                <div>
                    <span class="import-errors" [ngClass]="{'hide': importErrors==0}">{{importErrors}} {{'IMPORT_ERRORS' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="add-folder-wrapper">
        <span class="add-folder-btn">
            <button id="add-folder-button" color="primary" mat-raised-button (click)="onAddFolderClick()" aria-label="Add folder.">
                <span class="mdi mdi-plus-box-outline"></span>
                <span class="add-button-label">{{'FOLDER' | translate}}</span>
            </button>
        </span>
    </div>
    <form [formGroup]="folderFormGroup">
        <div class="form-grid">
            <div class="protection-level-title form-grid-3">
                {{ 'PROTECTION_LEVEL' | translate }}
                <span role="application" class="fa-layers fa-fw clickable question-icon" (keyup.enter)="onProtectionLevelClick()" (click)="onProtectionLevelClick()">
                    <span tabindex="0" class="mdi mdi-help-circle-outline"></span>
                </span>
            </div>
            <div *ngIf="encryptionLevelButtons" class="encryption-level-title form-grid-4">
                {{ 'ENCRYPTION_LEVEL' | translate }}
                <span role="application" class="fa-layers fa-fw clickable question-icon" (keyup.enter)="onEncryptionLevelClick()" (click)="onEncryptionLevelClick()">
                    <span tabindex="0" class="mdi mdi-help-circle-outline"></span>
                </span>
            </div>

            <ng-container formArrayName="folders" *ngFor="let control of controls; let i = index;">
                <ng-container [formGroupName]="i">
                    <div *ngIf="show_environment_variables" class="form-grid-1">
                        <button id="env-var-{{i}}" color="accent" [matMenuTriggerFor]="menu" mat-icon-button [disableRipple]="true" matTooltip="Add environment variable"
                                matTooltipShowDelay="350" matTooltipPosition="right" aria-label="Add environment variable.">
                            <span class="mdi mdi-dots-horizontal"></span>
                        </button>
                        <mat-menu id="env-var-menu-{{i}}" #menu="matMenu">
                            <button id="homeEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${HOME}')" matTooltip="C:\Users\<username>" matTooltipShowDelay="500" matTooltipPosition="right">
                                ${{'{'}}HOME{{'}'}}
                            </button>
                            <button id="appDataEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${APPDATA}')" matTooltip="C:\Users\<username>\AppData\Roaming" matTooltipShowDelay="500" matTooltipPosition="right">
                                ${{'{'}}APPDATA{{'}'}}
                            </button>
<!--                                                    <button color="primary" id="allUserEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${ALLUSERSPROFILE}')" matTooltip="C:\ProgramData" matTooltipShowDelay="500" matTooltipPosition="right">
                                                        ${{'{'}}ALLUSERSPROFILE{{'}'}}
                                                    </button>-->
                            <button id="systemRootEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${SystemRoot}')" matTooltip="C:\Windows" matTooltipShowDelay="500" matTooltipPosition="right">
                                ${{'{'}}SystemRoot{{'}'}}
                            </button>
<!--                                                    <button id="userEnvButton-{{i}}" mat-menu-item (click)="onAddVariable(control, i, '${USERPROFILE}')" matTooltip="C:\Users\<username>" matTooltipShowDelay="500" matTooltipPosition="right">
                                                        ${{'{'}}USERPROFILE{{'}'}}
                                                    </button>-->
                        </mat-menu>
                    </div>

                    <div class="policy-path-form-field form-grid-2">
                        <mat-form-field appearance="outline">
                            <input matInput type="text" autocomplete="off" id="folder-path-{{i}}" class="folder-label" #folderPathInputs
                                   [ngClass]="{'input-error': hasFolderError(i)}"
                                   (focusin)="onFocusIn($event, i)"
                                   (focusout)="onFocusOut($event, i)"
                                   (input)="onInputChange($event, control, i)"
                                   formControlName="path"
                                   placeholder="Enter a valid folder path"/>
                            <mat-error *ngIf="hasFolderError(i)">{{folderErrors[i]}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-grid-3 toggle-group">
                        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" value="{{control.value.setting}}" formControlName="setting" (change)="onToggleChanged($event, control, i)" [appearance]="toggleGroupAppearance" name="policy-toggle-button-group">
                            <mat-button-toggle id="none-{{i}}" value="none-{{i}}" [disabled]="control.value.setting === ''" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
                            <mat-button-toggle id="medium-{{i}}" value="medium-{{i}}" [disabled]="control.value.setting === ''" disableRipple="true">Dynamic</mat-button-toggle>
                            <mat-button-toggle id="high-{{i}}" value="high-{{i}}" [disabled]="control.value.setting === ''" disableRipple="true">Always on</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                    <!-- BEGINNING OF ENCRYPTION LEVEL -->
                    <div *ngIf="encryptionLevelButtons" class="form-grid-4 toggle-group">
                        <span>
                            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" value="{{control.value.encryptedSetting}}" formControlName="encryptedSetting" (change)="onEncryptionToggleChanged($event, control, i)" [appearance]="toggleGroupAppearance" name="encrypt-toggle-button-group">
                                <mat-button-toggle id="none-encrypted-{{i}}" value="none-encrypted-{{i}}" [disabled]="control.value.setting.startsWith('none')" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
                                <mat-button-toggle id="encrypted-{{i}}" value="encrypted-{{i}}" [disabled]="control.value.setting.startsWith('none') || !enableSubscriptionKey" disableRipple="true">Subscription</mat-button-toggle>
                            </mat-button-toggle-group>
                        </span>
                    </div>
                    <div class="remove-row-icon form-grid-5">
                        <button mat-icon-button (click)="removePathRow(control.value.path, i)" matTooltip="{{'REMOVE_FILE_PATH' | translate}}"
                                matTooltipShowDelay="350" matTooltipPosition="right" attr.aria-label="{{'REMOVE_FILE_PATH' | translate}}">
                            <span class="mdi mdi-close-circle-outline"></span>
                        </button>
                    </div>

                </ng-container>
            </ng-container>
        </div>
    </form>
</div>
